<script>
export default {
  props: {
    dishes: {
      type: Array,
      required: true,
      default: () => [],
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    lastClickableDishImg: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    toNutrition() {
      if (this.lastClickableDishImg) {
        this.$router.push({ name: 'nutrition' });
      }
    },
  },
};
</script>

<template>
  <div class="mealtime-dish-stack">
    <b-row>
      <b-col md="12" sm="12">
        <div class="mealtime-title">{{ title }}</div>
      </b-col>
      <div
        :class="['dish-image', { clickable: lastClickableDishImg }]"
        v-for="(dish, i) in dishes"
        v-lazy:background-image="dish.imageURL"
        :key="i"
        @click="toNutrition"
      >
        <BaseIcon class="icon-chevron" name="chevron-right" v-if="lastClickableDishImg" />
      </div>
    </b-row>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.mealtime-dish-stack {
  .mealtime-title {
    color: #888;
    font-size: 17.3529px;
    font-weight: bold;
    letter-spacing: 1.21922px;
    line-height: 2.4rem;
    margin-bottom: 10px;
    text-align: left;
    text-transform: uppercase;
  }

  .dish-image {
    background-position: center;
    background-size: cover;
    border-radius: $base-border-radius-md;
    float: right;
    height: 4.5rem;
    margin: 10px 0 2px 12px;
    position: relative;
    width: 4.5rem;

    // iPhone 6 up
    @include media('md', null) {
      height: 6rem;
      width: 6rem;
    }

    // XL Tablet up
    @include media('xl', null) {
      height: 7rem;
      width: 7rem;
    }

    // XXL Tablet up
    @include media('xxl', null) {
      height: 8rem;
      width: 8rem;
    }

    &.clickable {
      .icon-chevron {
        display: none;
      }
    &:not(:first-child){
      &:last-child {
        align-items: center;
        background-image: unset !important;
        display: flex;
        justify-content: center;

        &::before {
          background-color: #d8d8d8;
          border-radius: $base-border-radius-md;
          bottom: 0;
          content: '';
          left: 0;
          position: absolute;
          right: 0;
          top: 0;
          z-index: 1;
        }

        &:hover {
          cursor: pointer;
        }

        .icon-chevron {
          display: block;
          font-size: 2.6rem;
          position: relative;
          z-index: 1;
        }
      }
    }
    }

    &:not(:last-child) {
      margin-bottom: 0;

      // XL Tablet up
      @include media('xxl', null) {
        margin-bottom: 1.7rem;
      }
    }
  }
}
</style>
